module.exports = __webpack_public_path__ + "img/新疆天汇华尚二手车交易有限公司.53358ac6.jpg";